/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/24/20
 *
 */
import BaseObject from "@shared/BaseObject.js";


export default class OAuthToken extends BaseObject{

	access_token: string = ""
	refresh_token: string = ""
	id_token: string = ""
	scope: string = ""
	token_type: string = ""
	expiry_date: number = 0
	expires_in: number = 0
	expires_at: string = null
}
